import React from 'react'
import Link from 'gatsby-link'
import Scroll from 'react-scroll'

import logo from '../img/logo.png'

export default () => (
		<header>
			<nav className="navbar navbar-default navbar-fixed-top">
				<div className="container-fluid">
					<div className="row">
						<div className="navbar-header">
							<button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"
							    aria-expanded="false">
								<span className="sr-only">Toggle navigation</span>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
								<span className="icon-bar"></span>
							</button>
							<a className="navbar-brand scroll-link logo" href="#home" data-id="home">
								<img src={logo} height="42" /> &nbsp; Savage Squid Inc.</a>
						</div>

						<div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
							<ul className="nav navbar-nav navbar-right">
								<li>
									<a href="#" onClick={Scroll.animateScroll.scrollToTop} data-id="home" className="scroll-link">Home</a>
								</li>
								<li>
									<Scroll.Link to="about" href="#about" spy={true} smooth={true} data-id="about" className="scroll-link">About</Scroll.Link>
								</li>
								<li>
									<Scroll.Link to="work" href="#work" spy={true} smooth={true} data-id="work" className="scroll-link">Work</Scroll.Link>
								</li>
								<li>
									<Scroll.Link to="contact" href="#contact" spy={true} smooth={true} data-id="contact" className="scroll-link">Contact</Scroll.Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</nav>
		</header>
)



// WEBPACK FOOTER //
// ./src/components/header.js